/**
 * Motion Tokens — single source of truth for all animation values.
 *
 * Only three durations allowed:
 *   fast = 180ms  (micro-interactions: buttons, toggles, icons)
 *   normal = 280ms (standard UI: cards, panels, filters)
 *   slow = 450ms  (reveal: page enter, dialog open, charts)
 *
 * No arbitrary durations anywhere in the app.
 */

export const duration = {
  fast: 180,
  normal: 280,
  slow: 450,
} as const

/**
 * Easing tokens — three profiles for the entire app.
 *
 * interactive — ease-out; buttons, inputs, controls
 * surface    — cubic-bezier(0.22,1,0.36,1); cards, panels, menus
 * navigation — cubic-bezier(0.4,0,0.2,1); route changes
 */
export const easing = {
  interactive: 'ease-out',
  surface: 'cubic-bezier(0.22, 1, 0.36, 1)',
  navigation: 'cubic-bezier(0.4, 0, 0.2, 1)',
} as const

/**
 * Spring presets for JS-driven animations.
 */
export const spring = {
  /** Buttons, toggles, interactive elements */
  interactive: { stiffness: 320, damping: 30 },
  /** Cards, sheets, panels */
  surface: { stiffness: 180, damping: 22 },
  /** Shared elements, large surface movement */
  hero: { stiffness: 140, damping: 18 },
} as const

export type DurationToken = keyof typeof duration
export type EasingToken = keyof typeof easing
